import api from "../../../services/api";

export interface GenderEcommCategoryReport {
  category: string;
  units_sold: number;
  revenue: number;
}

export const getEcommGenderCategoryReport = async (
  start_date: string,
  end_date: string
) => {
  const response = await api.get("/api/shopify/sales_reports/categorize_by_gender", {
    params: { start_date, end_date },
  });
  return response.data as GenderEcommCategoryReport[];
};